Ext.ns('mx.app.widget');

mx.app.widget.PolygonForm = Ext.extend(mx.comp.FormPanel, {
    layout: 'row',
    border: false,
    header: false,
    height: 550,
    readOnly: false,
    params: {},
    labels: {
        map: 'Map',
        searchPosition: 'Search position',
        search: 'Search',
    },
    inputs: {}, // collection of input elements
    components: {},
    initComponent: function() {
        mx.app.widget.MapForm.superclass.initComponent.apply(this, arguments);
        var thiz = this;

        thiz.addEvents('mapclicked', 'mapready');

        this.inputs = {
            searchTextfield: new Ext.form.TextField({
                name: 'search_text',
            }),
            searchButton: new Ext.ux.ResizableButtonComponent({
                name: 'search_text_btn',
            }),
        };

        // init map component
        this.components.mapComponent = new mx.comp.mapComponent({
            id: this.id,
            mapParams: this.mapParams,
            line: null,
            isReverseGeocodingOnClick: false,
            noMap: function() {
                return this.theMap == null || this.theMap.noMap();
            },
            addPolylineFromPoints: function(points) {
                if (!this.noMap()) {
                    var mxnPoints = [];
                    var thiz = this;
                    points.forEach(function(point) {
                        mxnPoints.push(new thiz.theMap.mxn.LatLonPoint(point.lat, point.lon));
                    });
                    this.line = new this.theMap.mxn.Polyline(mxnPoints);
                    this.line.setColor('#FF0000');
                    this.line.setWidth(3);
                    this.theMap.addPolyline(this.line);
                    if (this.line.isClosed()) {
                        this.theMap.centerOnObjects([this.line]);
                    }
                }
            },
            addPointToPolyline: function(point) {
                if (!this.noMap()) {
                    if (this.line == null) {
                        this.addPolylineFromPoints([point]);
                    } else if (!this.line.isClosed()) {
                        this.line.addPoint(new this.theMap.mxn.LatLonPoint(point.lat, point.lon));
                        if (this.line.points.length > 1) {
                            this.theMap.centerOnObjects([this.line]);
                        }
                    }
                }
            },
            getPolylinePoints: function() {
                return this.line ? this.line.getPoints() : [];
            },
            getPolyline: function() {
                return this.line ? this.line : null;
            },
            clearPolyline: function() {
                if (!this.noMap()) {
                    this.line = null;
                    this.theMap.removeAllPolylines();
                }
            },
            geocodingCallback: function(point) {
                thiz.components.mapComponent.updateCurrentPoint(point);
            },
            callback: function(point) {
                // click on map callback
                thiz.components.mapComponent.addPointToPolyline(point);
                thiz.fireEvent('mapclicked', {});
            },
            onMapReadyCallback: function(aMap) {
                // search for initial address (not implemented)
                // todo: restore polygon from textfield
                thiz.fireEvent('mapready');
            },
            searchOnMap: function(text) {
                if (text) {
                    if (!this.noMap()) {
                        this.theMap.geocodingBasis({address: text});
                    } else {
                        console.log('map error');
                    }
                }
            },
            addressFormatter: MXBT.formatAddress.createDelegate(MXBT),
        });

        // init search textfield
        this.inputs.searchTextfield.initEvents = function() {
            Ext.form.TextField.superclass.initEvents.call(this);
            this.keyNav = new Ext.KeyNav(this.el, {
                enter: function(e) {
                    this.inputs.searchButton.fireEvent('click');
                },
                scope: thiz,
            });
            this.el.on(
                'keyup',
                function() {
                    this.inputs.searchButton.setDisabled(
                        Ext.util.Format.trim(this.inputs.searchTextfield.getValue()).length == 0
                    );
                },
                thiz
            );
        };

        // init search button
        this.inputs.searchButton.setText(this.labels.search);
        if (!name || Ext.util.Format.trim(name).length == 0) {
            this.inputs.searchButton.setDisabled(true);
        }
        this.inputs.searchButton.on(
            'click',
            function() {
                if (Ext.util.Format.trim(this.inputs.searchTextfield.getValue()).length == 0) {
                    this.inputs.searchButton.setDisabled(true);
                } else {
                    this.components.mapComponent.searchOnMap(this.inputs.searchTextfield.getValue());
                }
            },
            thiz
        );

        // build window together:
        this.add(
            {
                layout: 'fit',
                border: false,
                rowHeight: 1,
                style: 'margin-bottom: 0px',
                items: [this.components.mapComponent],
            },
            {
                layout: 'form',
                height: 25,
                width: 500,
                border: false,
                defaults: {
                    anchor: '100%',
                },
                items: [
                    {
                        xtype: 'mx_fieldgroup',
                        fieldLabel: this.labels.searchPosition,
                        columns: [0.8, 10, 0.2],
                        items: [
                            this.inputs.searchTextfield,
                            {
                                xtype: 'label',
                                text: ' ',
                            },
                            this.inputs.searchButton,
                        ],
                    },
                ],
            }
        );
    },
});
